<template>
    <div>
        <div class="head">
            <div class="head-left">
                <div class="head-logo">
                    <i class="fa fa-shield"></i>
                </div>
                <div>
                    <div class="name">{{head.name}} <a-button type="default" size="small" class="back" @click="getBack">返回</a-button></div>
                    <div class="desc">
                        <small><i class="fa fa-circle text-navy"></i> </small>
                        <small> {{head.status}}</small>
                        <small>品牌: </small>
                        <small>{{head.brand}}</small>
                        <small>型号: </small>
                        <small>{{head.model}}</small>
                        <small>序列号: </small>
                        <small>{{head.sequence}}</small>
                    </div>
                </div>
            </div>
            <div class="head-right">
                <div>
                    <div>{{head.zjrl}}</div>
                    <div><small>组件容量(kWp)</small></div>
                </div>
                <div>
                    <div>{{head.jnwd}}</div>
                    <div><small>机内温度(°C)</small></div>
                </div>
                <div>
                    <div>{{head.glys | fixedNormalLength}}</div>
                    <div><small>功率因素</small></div>
                </div>
            </div>
        </div>
        <a-row :gutter="10">
            <a-col :span="12">
                <div class="tab-content">
                    <a-tabs defaultActiveKey="1">
                        <a-tab-pane tab="常用" key="1">
                            <a-col :span="12" class="data-info">
                                <div>总有功功率：<span>{{tabs.one.zyggl}} w</span></div>
                                <div>输出功率：<span>{{tabs.one.scgl}} Kw</span></div>
                                <div>无功功率：<span>{{tabs.one.wggl}} var</span></div>
                            </a-col>
                            <a-col :span="12" class="data-info">
                                <div>总直流功率：<span>{{tabs.one.zzlgl}}W</span></div>
                                <div>电网频率：<span>{{tabs.one.dwgl}} Hz</span></div>
                                <div>功率因素：<span>{{tabs.one.glys | fixedNormalLength}}</span></div>
                            </a-col>
                        </a-tab-pane>
                        <a-tab-pane tab="直流侧" key="2" forceRender>
                            <a-col :span="12" class="data-info">
                                <div>MPPT1 U/I：<span>{{tabs.two.V1}} V {{tabs.two.I1}} A</span></div>
                                <div>MPPT3 U/I：<span>{{tabs.two.V3}} V {{tabs.two.I3}} A</span></div>
                                <div>MPPT5 U/I：<span>{{tabs.two.V5}} V {{tabs.two.I5}} A</span></div>
                            </a-col>
                            <a-col :span="12" class="data-info">
                                <div>MPPT2 U/I：<span>{{tabs.two.V2}} V {{tabs.two.I2}} A</span></div>
                                <div>MPPT4 U/I：<span>{{tabs.two.V4}} V {{tabs.two.I4}} A</span></div>
                                <div>MPPT6 U/I：<span>{{tabs.two.V6}} V {{tabs.two.I6}} A</span></div>
                            </a-col>
                        </a-tab-pane>
                        <a-tab-pane tab="交流侧" key="3">
                            <a-col :span="12" class="data-info">
                                <div>A-B线电压/A相电压：<span>{{tabs.three.AB}} V</span></div>
                                <div>B-C线电压/B相电压：<span>{{tabs.three.BC}} V</span></div>
                                <div>C-A线电压/C相电压：<span>{{tabs.three.CA}} V</span></div>
                            </a-col>
                            <a-col :span="12" class="data-info">
                                <div>A相电流：<span>{{tabs.three.A}} A</span></div>
                                <div>B相电流：<span>{{tabs.three.B}} A</span></div>
                                <div>C相电流：<span>{{tabs.three.C}} A</span></div>
                            </a-col>
                        </a-tab-pane>
                    </a-tabs>
                </div>

                <div style="height: 600px;">
                    <inverter-elector-power ref="inverterElectorPower"></inverter-elector-power>
                </div>


            </a-col>
            <a-col :span="12">

                <div style="height: 765px; ">
                    <inverter-ratio ref="inverterRatio"></inverter-ratio>
                </div>
            </a-col>
        </a-row>


    </div>
</template>

<script>
    import inverterElectorPower from "./inverterElectorPower";
    import inverterRatio from "./inverterRatio";
    export default {
        name: "inverterDetail",
        components:{
            inverterElectorPower,
            inverterRatio
        },
        data(){
            return {
                inverterId: 0,
                head:{
                    name: '',
                    status: '正常运行',
                    brand: '',
                    model: '',
                    sequence: '',
                    zjrl: 0,
                    jnwd: 0,
                    glys: 0
                },
                tabs: {
                    one: {
                        zyggl: 0,
                        scgl: 0,
                        wggl: 0,
                        zzlgl: 0,
                        dwgl: 0,
                        glys: 0,
                    },
                    two: {
                        I1: 0,
                        I2: 0,
                        I3: 0,
                        I4: 0,
                        I5: 0,
                        I6: 0,
                        V1: 0,
                        V2: 0,
                        V3: 0,
                        V4: 0,
                        V5: 0,
                        V6: 0,
                    },
                    three: {
                        AB: 0,
                        BC: 0,
                        CA: 0,
                        A: 0,
                        B: 0,
                        C: 0
                    }

                }
            }
        },
        methods:{
            initInverter(obj){
                this.inverterId = obj.inverterId;
                this.head.name = obj.inverterName;
                this.head.brand = obj.brand || '暂无品牌';
                this.head.model = obj.model || '暂无型号';
                this.head.sequence = obj.sequence;
                this.head.status = obj.runStatusName;
                this.head.zjrl = obj.capacity;
                this.head.jnwd = obj.interAirTemp;
                this.head.glys = obj.totalPowerFactor;
                this.tabs.one.zyggl = obj.totalActivePower;
                this.tabs.one.wggl = obj.totalIdlePower;
                this.tabs.one.scgl = (this.tabs.one.zyggl + this.tabs.one.wggl) / 1000;
                this.tabs.one.zzlgl = obj.totalDCPower;
                this.tabs.one.dwgl = obj.gridFrequency;
                this.tabs.one.glys = obj.totalPowerFactor;
                this.tabs.two.I1 = obj.idc1;
                this.tabs.two.I2 = obj.idc2;
                this.tabs.two.I3 = obj.idc3;
                this.tabs.two.I4 = obj.idc4;
                this.tabs.two.I5 = obj.idc5;
                this.tabs.two.I6 = obj.idc6;
                this.tabs.two.V1 = obj.vdc1;
                this.tabs.two.V2 = obj.vdc2;
                this.tabs.two.V3 = obj.vdc3;
                this.tabs.two.V4 = obj.vdc4;
                this.tabs.two.V5 = obj.vdc5;
                this.tabs.two.V6 = obj.vdc6;
                this.tabs.three.AB = obj.lineVABorPhaseVA;
                this.tabs.three.BC = obj.lineVBCorPhaseVB;
                this.tabs.three.CA = obj.lineVCAorPhaseVC;
                this.tabs.three.A = obj.phaseIA;
                this.tabs.three.B = obj.phaseIB;
                this.tabs.three.C = obj.phaseIC;


                this.$refs.inverterElectorPower.initCharts(this.inverterId);
                this.$refs.inverterRatio.initCharts(this.inverterId);



                console.log('inverter',  obj)
            },
            getBack(){
                this.$emit('backTable', true);
            }
        }
    }
</script>

<style lang="less" scoped>
    .head {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px;
        border-bottom: 1px solid #eee;
        margin-bottom: 10px;
        .head-left{
            display: flex;
            .head-logo{
                display: flex;
                align-items: center;
                padding: 10px;
                font-size: 30px;
                color: #1ab394;
            }
            .name {
                color: #1ab394;
                font-size: 18px;
                font-weight: 600;
                height: 27px;
            }
            .desc{
                color: #999;
                small:nth-child(even){
                    margin-right: 10px;
                }
            }
        }

        .head-right{
            display: flex;
            text-align: center;
            align-items: center;
            & > div {
                padding: 0 20px;
                div:first-child{
                    font-size: 24px;
                    line-height: 18px;
                    font-weight: 400;
                    margin-bottom: 5px;
                }
                small {
                    color: #999;
                }
            }
        }
    }

    .tab-content {
        border:1px solid #eee;
        margin-bottom: 10px;
        .data-info {
            & > div {
                padding: 0 20px;
                margin-bottom: 10px;
                font-weight: 600;
                color: #676a6c;
                span{
                    background-color: #1ab394;
                    color: #fff;
                    padding: 0 10px;
                    border-radius: 10px;
                    font-size: 12px;
                }
            }
        }

    }
</style>
